import React from "react";
import s from "./Checkbox.module.scss";
import { isNullish } from "utils/utils";

const Checkbox = ({ oncheckFn, checked, indeterminate, disabled, id }) => {
  return (
    <input
      id={id}
      disabled={disabled}
      type="checkbox"
      className={s.checkbox}
      onChange={oncheckFn}
      checked={checked}
      {...(!isNullish(indeterminate) && {
        ref: (e) => {
          if (e) {
            e.indeterminate = indeterminate;
          }
        },
      })}
    />
  );
};

export default React.memo(Checkbox);
